import MsxIcons from "../../../../Common/components/Icons/MsxIcons/MsxIcons";
import ProductDataSheetLink from "../../../../Common/components/Shared/ProductDataSheetLink";
import { NO_GEARBOX, NO_MOTOR } from "../../../store/data/cartesianData";
import t from "../../../../Common/utils/translation/translator";

const ProductCard = ({
  title,
  imageAlt,
  imageUrl,
  reference,
  description,
  orientationMountingSide,
  mounted,
  onClickMount,
  characteristics,
  ...props
}) => (
  <div className="ProductCard border-[1px] overflow-hidden shadow-sm" {...props}>
    <span className="bg-gray-400 text-white px-4 text-center rounded-br-3xl block w-24">{title}</span>
    <div className="grid grid-cols-3 gap-4 p-[0.25rem]">
      <div className="col-span-1 flex items-center space-x-5">
        <div>
          {/* the image must be grayed if it's not mounted */}
          <img className={!mounted && "opacity-40"} alt={imageAlt} src={imageUrl} />
        </div>
        <div className="flex flex-col space-y-1">
          <span className={`text-secondary underline font-semibold cursor-pointer text-xs ${!mounted && "hidden"}`}>
            <ProductDataSheetLink reference={reference} />
          </span>
          <span className={`font-semibold text-black ${!mounted && "hidden"}`}>{description}</span>
          {!mounted && (
            <div className="h-9">
              <div className="p-[0.25rem] rounded flex items-center space-x-2 bg-[#42B4E640]">
                <MsxIcons name="info-tooltip" size="nano" className="mt-1" />
                <span>{t("cartesian.ui.axis_options.only_motor_adapter")}</span>
              </div>
            </div>
          )}
          {/*
          // MSC-1500
          <div className="flex space-x-1 items-center -ml-1">
            <span className="transform scale-75">
              <ToggleInput checked={mounted} switchable onChange={() => onClickMount(reference)} />
            </span>
            <span className="-mt-1">
              {mounted ? t("cartesian.ui.axis_options.mounted") : t("cartesian.ui.axis_options.adapter_only")}
            </span>
          </div> */}
        </div>
      </div>
      <div className="col-span-2 flex space-x-5 divide-x-2 items-center">
        {orientationMountingSide && (
          <div className={`flex space-x-5 ${!mounted && "opacity-40"}`}>
            <div className="flex flex-col">
              <span className="underline">{t("cartesian.ui.axis_options.orientation")}</span>
              <span className="font-semibold">
                {orientationMountingSide?.orientation === NO_MOTOR ||
                orientationMountingSide?.orientation === NO_GEARBOX
                  ? orientationMountingSide?.orientation
                  : orientationMountingSide?.orientation + "\u00B0"}
              </span>
            </div>
            <div className="flex flex-col">
              <span className="underline">{t("cartesian.ui.axis_options.mounting_side")}</span>
              <span className="font-semibold">{orientationMountingSide?.mountingSide}</span>
            </div>
          </div>
        )}
        <div className="flex space-x-5 pl-5">
          {mounted &&
            characteristics?.map((characteristic, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className="flex flex-col">
                <span className="underline">{characteristic?.title}</span>
                <span className="font-semibold">{characteristic?.value}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  </div>
);
export default ProductCard;
